import React, { useCallback, useEffect, useRef, useState } from "react"
import { useForm } from "react-hook-form"
import { useParams } from "react-router"
import Send from "../../core/communication"
import AssistanceLinkFormStepsScreen from "../../screen/AssistanceLinkFormStepsScreen"
import { processFile } from "../../core/utils/hooks/uploadItem"
import { customToast } from "../../components/Toast"
import { useNavigate, useLocation, useSearchParams } from "react-router-dom"
import { debounce } from "lodash"
import swal from "sweetalert"
import { isMobile } from "react-device-detect"
import { useScope } from "../SelectProjectCompanyContainer"
import { useOnlineStatus } from "../../core/utils/hooks/useUsers"
import { useNetworkState } from "react-use"
import { ChatProvider, useChatContext } from "../../core/context/chatContext"

function checkQuestionResponse(objeto) {
  for (const propriedade in objeto) {
    if (objeto.hasOwnProperty(propriedade)) {
      const valor = objeto[propriedade]

      if (valor !== null && valor !== undefined && valor !== "" && valor !== "Ø") {
        return false
      }
    }
  }

  return true
}

var options = {
  enableHighAccuracy: true,
  timeout: 5000,
  maximumAge: 0,
}

const AssistanceLinkFormSteps = ({ isOffline }) => {
  const { register, control, getValues, reset, unregister, setValue } = useForm({
    mode: "onBlur",
  })
  const {
    pinnedMessages,
    pinnedMessagesQuestions,
    resetPinnedMessages,
    setFixedMessage,
    fixedMessage,
    setEvidenceId,
    removePinnedMessage,
    isLoadingTestimonial
  } = useChatContext()

  const navigate = useNavigate()
  const location = useLocation()
  const { formId, userId, userCreated, projectId, userName, phone, userForm } = location.state || {}
  const { scope, scopeType } = useScope()
  const { hashId } = useParams()
  const [searchParams] = useSearchParams()
  const [stepQuestions, setStepQuestions] = useState({})
  const [stepsFilter, setStepFilter] = useState({})
  const [questionsSearchTerm, setQuestionsSearchTerm] = useState("")
  const [valuesQuestions, setValuesQuestions] = useState({})
  const [loadingProcessImage, setLoadingProcessImage] = useState(false)
  const [saving, setSaving] = useState(false)
  const [saved, setSaved] = useState(false)
  const [loadingQuestions, setLoadingQuestions] = useState(false)
  const [uploaded, setUploaded] = useState("")
  const [uploadedFiles, setUploadFile] = useState({})
  const [uploadedFilesEvidence, setUploadedEvidences] = useState([])
  const [geolocation, setGeolocation] = useState("")
  const callback = searchParams.get("callback")
  const [conditionalAnswers, setConditionalAnswers] = useState({})
  const [filterOpen, setFilterOpen] = useState(false)
  const [openEvidenceScreen, setOpenEvidence] = useState(null)
  const [isSystemChat, setIsSystemChat] = useState(false)
  const [openChatModal, setOpenModalChat] = useState(false)
  const isOnline = useOnlineStatus()
  const { online } = useNetworkState()
  const [startedAt, setStartedAt] = useState(null)
  const [isFilled, setIsFilled] = useState(null)

  useEffect(() => {
    setConditionalAnswers([])
  }, [])

  useEffect(() => {
    if (!startedAt) {
      setStartedAt(new Date())
    }
  }, [])

  useEffect(() => {
    getUserLocation()
  }, [])

  useEffect(() => {
    if (isMobile) {
      window.scrollTo(0, window.scrollY)
    }
  }, [valuesQuestions])

  /*   useEffect(() => {
    if (pinnedMessages && pinnedMessages?.length > 0) {
      setValuesQuestions((curr) => {
        const key = `${openEvidenceScreen}-messages`
        const existingMessages = curr[key] || []
        const combined = [...existingMessages, ...pinnedMessages]

        const uniqueById = Array.from(new Map(combined.map((msg) => [msg?.id, msg])).values())

        return {
          ...curr,
          [key]: uniqueById,
        }
      })
      setFixedMessage(pinnedMessages)
    }
  }, [pinnedMessages]) */

  const handleChangeAnswer = (id, value) => {
    setConditionalAnswers((curr) => ({ ...curr, [id]: value }))
  }

  const handleRemoveEvidence = (id, evidenceId) => {
    const key = `${id}-evidence`
    const newEvidenceList = valuesQuestions[key]?.filter(evd => evd.url !== evidenceId) || []

    setValuesQuestions(curr => ({
      ...curr,
      [key]: newEvidenceList,
    }))
  }

  function success(pos, answer) {
    const { latitude, longitude } = pos.coords
    if (answer) {
      onChangeQuestionsInfo(answer.type, `${latitude}|${longitude}`, answer?.id, answer)
    } else {
      setGeolocation(`${latitude}|${longitude}`)
    }
  }

  const getUserLocation = async (answer = null) => {
    const hasGeolocationQuestion =
      Array.isArray(stepQuestions?.steps) &&
      stepQuestions.steps.some((step) =>
        step?.fields?.some((item) => item?.type?.toLowerCase?.() === "geolocation"),
      )

    if ("geolocation" in navigator) {
      navigator.geolocation.getCurrentPosition(
        (pos) => success(pos, answer),
        (err) => {
          console.error(`ERROR(${err.code}): ${err.message}`)
          if (isMobile && hasGeolocationQuestion) {
            customToast(
              "Para inserir sua localização automaticamente, ative as permissões de localização nas configurações do navegador do seu celular.",
              "error"
            )
          }
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      )
    } else {
      customToast(
        "Geolocalização não é suportada neste navegador.",
        "error"
      )
    }
  }

  const didSetGeolocation = useRef(false)

  useEffect(() => {
    if (
      !didSetGeolocation.current &&
      stepQuestions?.steps?.length > 0 &&
      geolocation !== ""
    ) {
      for (const step of stepQuestions.steps) {
        for (const question of step.fields || []) {
          if (question?.type === "geolocation") {
            onChangeQuestionsInfo(question.type, geolocation, question.id, question)
            setValue(question.id, geolocation)
          }
        }
      }
      didSetGeolocation.current = true
    }
  }, [stepQuestions, geolocation])

  const loadQuestion = async () => {
    setLoadingQuestions(true);

    try {
      let result;

      if (hashId) {
        result = await Send.post(`/assistance-link-form/questions/many`, { hashId });
      } else {
        const response = await Send.get(
          `/assistance-link-form/questions/offline/form/${formId}/project/${scope?.id}`,
          `scopeType=${scopeType}`,
        );

        result = {
          ...response,
          producers: [userId],
        };
      }

      if (result?.status === "ERROR") {
        throw new Error(result?.message);
      }

      if (
        result &&
        result?.steps &&
        result?.steps?.find(
          (item) =>
            item.title === "Princípio 1 – Cumprimento à legislação" &&
            item?.title?.toLowerCase()?.includes("aceite"),
        )
      ) {
        const stepsWithSortedOptions = result.steps.map((step) => ({
          ...step,
          fields:
            step.fields?.map((field) => ({
              ...field,
              options: field.options?.slice().sort((a, b) => a.localeCompare(b)) ?? [],
            })) ?? [],
        }));

        const sortedSteps = [...stepsWithSortedOptions].sort((a, b) =>
          a.title.localeCompare(b.title),
        );

        setStepQuestions({ ...result, steps: sortedSteps });
      } else if (result?.steps) {
        setStepQuestions(result);
      } else {
        setSaved(true);
      }


    } catch (error) {
      console.error("Erro ao buscar questões:", error);

      if (error?.message === "O formulário já foi preenchido") {
        setIsFilled(error?.message)
      }
      else {
        customToast(`Erro ao buscar questões`, "error");
      }
    } finally {
      setLoadingQuestions(false);
    }
  };

  useEffect(() => {
    loadQuestion()
  }, [])

  const onChangeQuestionsInfo = (name, values, formQuestionId, formQuestion) => {

    if (
      (name === "select" &&
        formQuestion.typeIsMulti == "multiple" &&
        formQuestion.isMulti == "true")
    ) {
      let formattedValue = Array.isArray(values)
        ? [...new Set(values.map((value) => `${value.label}`))]
        : values

      formattedValue = Array.isArray(formattedValue)
        ? formattedValue.map((value, idx) => {
          const isTheLastPosition = idx !== values.length - 1

          return isTheLastPosition ? `${value}|` : value
        })
        : values

      formattedValue = formattedValue ? formattedValue.toString().replaceAll("|,", "|") : ""

      setValuesQuestions({
        ...valuesQuestions,
        [formQuestionId]: !formattedValue || formattedValue === "" ? "Ø" : formattedValue,
      })
      handleChangeAnswer(formQuestionId, values)

      return
    }

    if (
      name === "radio" ||
      name === "users" ||
      (name === "select" &&
        formQuestion.typeIsMulti !== "multiple" &&
        formQuestion.isMulti !== "true")
    ) {
      const formattedData = Array.isArray(values)
        ? values?.map((row) => row.label).join("|")
        : values?.label

      setValuesQuestions({
        ...valuesQuestions,
        [formQuestionId]: formattedData,
      })
      handleChangeAnswer(formQuestionId, values)
      setValue(formQuestionId, formattedData)

      return
    }

    if (name === "checkbox") {
      setValuesQuestions({
        ...valuesQuestions,
        [formQuestionId]: values
      })
      handleChangeAnswer(formQuestionId, values)
      setValue(formQuestionId, values)
      return
    }

    setValuesQuestions({
      ...valuesQuestions,
      [formQuestionId]: values,
    })
    setValue(formQuestionId, values)

    handleChangeAnswer(formQuestionId, values)
  }

  const onChangeFile = async (e, questionId, existingFiles = []) => {
    const chosenFiles = Array.from(e.target.files)

    if (e.target?.remove) {
      setUploadFile({
        ...uploadedFiles,
        [questionId]: null,
      })
      return
    }

    try {
      setLoadingProcessImage(questionId)

      const processedFiles = await Promise.all(chosenFiles.map(processFile))
      const uniqueFiles = [...new Set(processedFiles)]
      const formattedValue = uniqueFiles.join("|")

      setUploadFile({
        ...uploadedFiles,
        [questionId]: formattedValue,
      })

      setUploaded(questionId)

      customToast("Arquivos enviados com sucesso", "success")
    } catch (error) {
      customToast("Erro ao fazer upload dos arquivos", "error")
    } finally {
      setLoadingProcessImage("")
      e.target.value = null
    }
  }

  const saveFormSubmission = async () => {
    const mergeFileLinksWithQuestions = {
      ...uploadedFiles,
      ...uploadedFilesEvidence,
      ...valuesQuestions,
      ...pinnedMessagesQuestions,
    }

    const description = `Iniciado em: ${startedAt.toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })}, finalizado em: ${new Date().toLocaleString('pt-BR', { dateStyle: 'short', timeStyle: 'short' })}`

    if (checkQuestionResponse(mergeFileLinksWithQuestions)) {
      /* customToast("Por favor, responda pelo menos uma pergunta", "error") */
      swal({
        title: "Erro!",
        text: "Por favor, responda pelo menos uma pergunta.",
        icon: "error",
        buttons: false,
        timer: 3000,
      })
      return
    }

    setSaving(true)

    const formSubmissionId = stepQuestions?.formSubmissionId
    const assistanceToResolveId = stepQuestions?.assistanceToResolveId

    let formattedData = []

    const normalizeAnswers = (answer) => {
      if (Array.isArray(answer)) {

        return answer
          .map((item) =>
            typeof item === "object" && item !== null ? item.value : item
          )
          .join("|")
      }

      if (typeof answer === "object" && answer !== null) {
        return answer.value
      }

      return answer
    }

    try {

      const getAllFields = (stepQuestions, hasHashId) => {
        return stepQuestions?.steps?.flatMap((step) => {
          if (hasHashId) {
            return step.groups?.flatMap((group) => group.fields || []) || [];
          }
          return step.fields || [];
        }) || [];
      }

      const hasHashId = hashId;

      const questions = getAllFields(stepQuestions, hasHashId)
        .map((formQuestion) => {
          const questionId = formQuestion.id;

          if (
            mergeFileLinksWithQuestions[questionId] !== undefined ||
            mergeFileLinksWithQuestions[questionId] === '0' ||
            mergeFileLinksWithQuestions[questionId] === 0
          ) {
            const evidenceLinks = mergeFileLinksWithQuestions[`${questionId}-evidence`];
            delete mergeFileLinksWithQuestions[`${questionId}-evidence`];

            const messageIds = mergeFileLinksWithQuestions[`${questionId}-messages`];
            delete mergeFileLinksWithQuestions[`${questionId}-messages`];

            return {
              formSubmission: formSubmissionId,
              formQuestion: questionId,
              value: normalizeAnswers(mergeFileLinksWithQuestions[questionId]),
              evidencesLinks:
                evidenceLinks?.length > 0
                  ? JSON.stringify(evidenceLinks.map((row) => row?.url))
                  : null,
              messageIds: messageIds?.length > 0 ? JSON.stringify(messageIds) : null,
            };
          }

          return {
            formSubmission: formSubmissionId,
            formQuestion: questionId,
            value: 'Ø',
          };
        })
        .filter(Boolean);

      formattedData = isOffline ? questions.filter((item) => item.value !== "Ø") : questions

      const response = await Send.postOffline(
        `/assistance-link-form/finish` + (assistanceToResolveId ? `/${assistanceToResolveId}` : ""),
        {
          contentToSave: formattedData,
          isOffline,
          formId,
          projectId,
          userId,
          geoLocationCoordinates: geolocation || null,
          userCreated,
          phone,
          description,
          userForm,
          hashId
        },
      )

      if (response.status === "error") throw new Error("Erro ao responder formulário.")

      /* customToast("Formulário respondido com sucesso", "success") */

      swal({
        title: "Sucesso!",
        text: "O formulário foi salvo com sucesso.",
        icon: "success",
        buttons: false,
        timer: 3000,
      })

      if (callback && callback === "conexao") {
        setTimeout(() => {
          window.open("https://conexao.impactools.social/", "_self")
        }, 5000)
      }

      if (isOffline) {
        navigate(-2)
      }
      setSaved(true)
    } catch (error) {
      console.log("Erro ao responder formulário", error)
      /* customToast(error.message, "error") */
      swal({
        title: "Erro!",
        text: "Houve uma falha ao salvar o formulário, tente novamente.",
        icon: "error",
        buttons: false,
        timer: 3000,
      })
    } finally {
      setSaving(false)
      reset(), unregister()
    }
  }

  const formattedMulti = (values) => {
    return Array.isArray(values)
      ? values
        .map((row, idx) => {
          const answerExists = values.slice(0, idx).find((item) => item.value === row.value)

          if (answerExists) return null

          return row
        })
        .filter((row) => row)
      : values
  }

  const handleBack = () => {
    if (callback && callback === "conexao") {
      navigate(-1)
    }
  }

  const handleBackIsOffline = () => {
    navigate(-1)
  }

  const handleClose = () => {
    if (callback && callback === "conexao") {
      window.open("https://conexao.impactools.social/", "_self")
    }
  }

  const loadSuggestions = (value) => {
    return fetch("https://servicodados.ibge.gov.br/api/v1/localidades/municipios")
      .then((response) => response.json())
      .then((data) =>
        data
          .map((item) => {
            return {
              value: item.nome,
              label: item.nome,
            }
          })
          .filter((item) => item.label.toLowerCase().includes(value.toLowerCase())),
      )
  }

  const loadLocation = useCallback(
    debounce((value, callback) => {
      loadSuggestions(value).then((options) => callback(options))
    }, 1800),
    [],
  )

  const groupOptions = stepQuestions?.groups
    ? stepQuestions.groups?.map(({ stepId, stepTitle }) => ({ label: stepTitle, value: stepId }))
    : []

  const handleChangeSteps = (name, value) => {
    setStepFilter((item) => ({ ...item, [name]: value }))

    if (name === "groups" && !value) {
      setStepFilter({})
      setQuestionsSearchTerm("")
    }
  }

  const handleUploadEvidence = async (files, questionId, resetInput) => {
    try {
      setLoadingProcessImage(questionId);

      const processedFiles = await Promise.all(
        files.map((file) => processFile(file, true))
      );

      const previousFiles = uploadedFilesEvidence?.[`${questionId}-evidence`] || []

      const uniqueFiles = Array.from(new Set([...previousFiles, ...processedFiles]))

      setUploadedEvidences({
        ...uploadedFilesEvidence,
        [`${questionId}-evidence`]: uniqueFiles
      })

      setValuesQuestions({
        ...valuesQuestions,
        [`${questionId}-evidence`]: uniqueFiles
      })

      handleChangeAnswer([`${questionId}-evidence`], uniqueFiles)

      customToast("Upload concluído com sucesso", "success");
    } catch (error) {
      customToast("Erro ao fazer upload dos arquivos", "error");
      console.error(error);
    } finally {
      setLoadingProcessImage("");
      if (resetInput) resetInput();
    }
  }

  const onChangeFileEvidence = async (e, questionId) => {
    const chosenFiles = Array.from(e.target.files)

    if (e.target?.remove) {
      setUploadedEvidences({
        ...uploadedFilesEvidence,
        [`${questionId}-evidence`]: null
      })
      return
    }

    await handleUploadEvidence(chosenFiles, questionId, () => {
      e.target.value = null
    })
  }

  const handleUploadPhotos = async (images) => {
    await handleUploadEvidence(images, openEvidenceScreen)
  }

  const handleOpenEvidence = (id) => {
    if (!isOnline || !online) {
      customToast("Você está offline, esta função está disponível somente", "warn")
      return
    }

    if (!valuesQuestions[id]) {
      customToast("Você deve preencher uma questão", "warn")
      return
    }

    setOpenEvidence(id)
    setEvidenceId(id)
  }

  const handleCloseEvidence = () => {
    setOpenEvidence(null)
  }

  const questionValues = formattedMulti(getValues())

  const handleChangeGeoLocation = (e) => {
    setGeolocation(e?.target.value)
  }

  const handleOpenChatModal = () => {
    setOpenModalChat(true)
    //resetPinnedMessages()
  }

  const handleCloseChatModal = () => {
    setOpenModalChat(false)
    //resetPinnedMessagesQuestions(openEvidenceScreen)
    resetPinnedMessages()
    //setEvidenceId(null)
  }

  const removeMessages = (id, questionId = null) => {
    removePinnedMessage(id, openEvidenceScreen || questionId)
  }

  useEffect(() => {
    if (pinnedMessages && pinnedMessages.length && !fixedMessage.length) {
      setFixedMessage(pinnedMessages)
      resetPinnedMessages()
    }
  }, [])

  return (
    <AssistanceLinkFormStepsScreen
      {...{
        formId,
        userId,
        pinnedMessages,
        pinnedMessagesQuestions,
        stepQuestions: applyFilterSteps(stepQuestions, stepsFilter, questionsSearchTerm),
        stepOptions: applyFilterStepsOptions(stepQuestions, stepsFilter),
        stepsFilter,
        groupOptions,
        handleChangeSteps,
        setQuestionsSearchTerm,
        questionsSearchTerm,
        onChangeFile,
        onChangeFileEvidence,
        onChangeQuestionsInfo,
        uploadedFiles,
        uploadedFilesEvidence,
        loadingProcessImage,
        control,
        register,
        setValuesQuestions,
        values: questionValues,
        conditionalAnswers,
        saveFormSubmission,
        loadingQuestions,
        saving,
        saved,
        valuesQuestions,
        handleBack: callback === "conexao" ? handleBack : null,
        handleClose: callback === "conexao" ? handleClose : null,
        handleBackIsOffline: isOffline ? handleBackIsOffline : null,
        loadLocation,
        getNewLoc: getUserLocation,
        handleChangeGeoLocation,
        geolocation,
        filterOpen,
        setFilterOpen,
        handleOpenEvidence,
        handleCloseEvidence,
        openEvidenceScreen,
        isSystemChat,
        setIsSystemChat,
        openChatModal,
        handleOpenChatModal,
        handleCloseChatModal,
        removeMessages,
        handleUploadPhotos,
        handleRemoveEvidence,
        startedAt,
        isLoadingTestimonial,
        isFilled,
        hashId
      }}
    />
  )
}

const AssistanceLinkFormStepsContainer = ({ isOffline }) => {
  return (
    <ChatProvider>
      <AssistanceLinkFormSteps isOffline={isOffline} />
    </ChatProvider>
  )
}

export default AssistanceLinkFormStepsContainer

export const applyFilterSteps = (stepQuestions, stepsFilter, questionsSearchTerm) => {
  let filteredSteps = stepQuestions.steps

  if (stepsFilter) {
    if (stepsFilter.steps) {
      filteredSteps = filteredSteps?.filter((item) => item.id === stepsFilter.steps)
    } else if (stepsFilter.groups) {
      filteredSteps = filteredSteps?.filter((item) => item.stepId === stepsFilter.groups)
    }
  }

  if (questionsSearchTerm && questionsSearchTerm.trim() !== "") {
    filteredSteps = filteredSteps
      .map((step) => ({
        ...step,
        fields: step.fields.filter((field) =>
          field.title?.toLowerCase().includes(questionsSearchTerm.trim().toLowerCase()),
        ),
      }))
      .filter((step) => step.fields.length > 0)
  }

  const filteredData = {
    ...stepQuestions,
    steps: filteredSteps,
  }

  return filteredData
}

export const applyFilterStepsOptions = (options, stepsFilter) => {
  let filteredData = options.steps

  if (stepsFilter && stepsFilter.groups) {
    filteredData = filteredData?.filter((item) => item.stepId === stepsFilter.groups)
  }

  return filteredData?.map(({ id, title }) => ({ label: title, value: id })) || []
}
